<!--
 * @Author: hongye
 * @Date: 2020-09-15 18:30:32
 * @LastEditTime: 2022-12-07 18:46:30
 * @Description: 
-->
<template>
  <div class="online_doc">
    <div class="online_doc_item">
      <p class="online_doc_item_top">
        <i class="iconfont iconapiwendang_jiekoushuoming"></i>
        <span>{{ $t("onlineDoc.接口说明") }}</span>
      </p>
      <p class="explain_info" v-html="$t(onlineData.apiDesc)"></p>
    </div>
    <div class="online_doc_item explain">
      <p class="online_doc_item_top">
        <i class="iconfont iconapiwendang_jiekoudizhi1x"></i>
        <span>{{ $t("onlineDoc.接口信息") }}</span>
      </p>
      <slot name="api_addr_info">
        <!-- <p class="api_addr_info api_addr_info_new" v-if="onlineData.isNoTest">{{ onlineData.isNoTest }}</p>
        <p class="api_addr_info api_addr_info_new" v-if="!onlineData.isNoTest">
          {{ $t('onlineDoc.测试地址') }}{{ onlineData.testApi + address }}</p>
        <p class="api_addr_info" v-if="!onlineData.isNoTest">{{ $t('onlineDoc.正式地址') }}{{ onlineData.proApi }}</p> -->
        <div class="api_info" v-if="onlineData.infos && onlineData.infos.length > 0">
          <div class="api_info_item" v-for="infoItem in onlineData.infos" :key="infoItem.key" >
            <template >
              <p
                class="api_addr_info"
                v-for="info in infoItem"
                :key="info.key"
              >
                <span class="info_key">{{$t( info.key)}} </span><span>{{ info.value }}</span>
              </p>
            </template>
          </div>
        </div>
        <p class="api_addr_info">
          {{ $t("onlineDoc.请求方法")
          }}<span>{{ onlineData.method || "POST" }}</span>
        </p>
        <p class="api_addr_info">
          {{ $t("onlineDoc.响应类型")
          }}<span>{{ onlineData.responseType || "JSON" }}</span>
        </p>
      </slot>
    </div>
    <div class="online_doc_item explain">
      <p class="online_doc_item_top">
        <i class="iconfont iconapiwendang_canshumiaoshusvg"></i>
        <span>{{ $t("onlineDoc.参数描述") }}</span>
      </p>
      <!-- 参数描述 table表格  -->
      <template v-for="(item, index) in onlineData.postDataList">
        <api-table
          :title="$t(item.title) || ''"
          :dataList="item.value"
          :key="index"
          :style="{ marginTop: index ? '20px' : '0' }"
        ></api-table>
      </template>
    </div>
    <div class="online_doc_item explain">
      <p class="online_doc_item_top">
        <i class="iconfont iconapiwendang_baowenmiaoshu"></i>
        <span>{{ $t("onlineDoc.报文描述") }}</span>
      </p>
      <!-- 报文描述  table表格  -->
      <template v-for="(item, index) in onlineData.responseDataList">
        <api-table
          :title="$t(item.title) || ''"
          :dataList="item.value"
          :key="index"
          :style="{ marginTop: index ? '20px' : '0' }"
        ></api-table>
      </template>
    </div>

    <apiBody
      name="onlineDoc.请求示例"
      :code="onlineData.requestCode"
      :codes="onlineData.requestCodes"
    />
    <apiBody
      name="onlineDoc.返回示例"
      :code="onlineData.responseCode"
      :codes="onlineData.responseCodes"
    />

    <div
      class="online_doc_item explain"
      v-if="onlineData.errcodeJson && onlineData.errcodeJson.length > 0"
    >
      <p class="online_doc_item_top">
        <i class="iconfont iconapiwendang_cuowudaima"></i>
        <span>{{ $t("onlineDoc.错误代码") }}</span>
      </p>

      <!-- 错误代码 -->
      <api-errcode-table :dataList="onlineData.errcodeJson"></api-errcode-table>
    </div>
  </div>
</template>

<script>
import apiTable from "../components/apiTable";
import apiErrcodeTable from "./apiErrcodeTable";
import apiBody from "./apiBody";
import { RESPONSE_SUCCESS } from "@/constants";
import { mapGetters, mapActions } from "vuex";
export default {
  components: { apiTable, apiErrcodeTable, apiBody },
  props: ["onlineData"],
  computed: {
    ...mapGetters(["token", "uuid"]),
    address() {
      return this.uuid.length > 0 ? `?uuid=${this.uuid}` : "";
    }
  },
  mounted() {
    // 已登录，this.uuid为空再去请求
    if (this.token && this.uuid.length == 0) {
      // 获取用户UUid
      this.getUUid();
    }
  },
  methods: {
    ...mapActions(["SET_UUID"]),
    getUUid() {
      this.$API.getCertificationInfo().then((res) => {
        if (res.code === RESPONSE_SUCCESS) {
          // 这里需要判断是否认证通过，认证通过，并且uuid为空，即需要保存
          if (res.data.auditStatus == 2 && this.uuid.length == 0) {
            this.SET_UUID(res.data.uuid);
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
.api_info {
  display: flex;
  border: 1px solid #d6d4d4;
  
  .api_info_item{
    border-right:1px solid #d6d4d4;
    padding: 10px;
    .api_addr_info{
      word-break: break-all;
    }
    .info_key{
      font-weight: 600;    
    }
  }
}
</style>
